import { useAuth } from '../context/AuthContext';

/**
 * M11b-3 — Zentrale Read-only-Erkennung für die App-UI.
 *
 * Liefert `true`, wenn der eingeloggte User im aktuell aktiven Tenant die Rolle
 * `advisor` (Steuerberater) hat — also einen FREMDEN Mandanten-Tenant aktiv hat,
 * in dem er nur lesen darf. In diesem Fall werden app-weit die Schreib-Aktionen
 * (Erstellen/Bearbeiten/Stornieren/Löschen/Mahnen/Zahlung/Festschreiben)
 * ausgeblendet bzw. deaktiviert, damit der Berater keine Buttons sieht, die
 * ohnehin serverseitig mit 403 enden.
 *
 * WICHTIG — rein KOSMETISCH: Dieser Hook ist KEINE Sicherheitsgrenze. Die harte
 * Sperre bleibt ausschließlich bei den Firestore-Rules und dem PHP-`requireWrite`
 * (beide LIVE, von M11b-3 unangetastet). Dieser Hook verbessert nur die UX, indem
 * er sinnlose Schreib-Einstiegspunkte für advisor entfernt. Niemals darf sich Code
 * für eine Autorisierungsentscheidung allein auf diesen Hook verlassen.
 *
 * Robustheit: `activeRole` ist bei Flag off / eigenem Tenant immer `'owner'`
 * (siehe AuthContext) — für ALLE Bestands-User (owner/member ohne aktiven
 * Fremd-Tenant) liefert der Hook daher `false`, die App verhält sich exakt wie
 * bisher. Ein fehlender/unbekannter `activeRole` (defensiv) führt ebenfalls zu
 * `false` (fail-open für die KOSMETIK, nie für die Autorisierung — die liegt
 * fail-closed bei Rules/PHP).
 *
 * @returns `true` nur wenn `useAuth().activeRole === 'advisor'`, sonst `false`.
 */
export function useIsReadOnly(): boolean {
  const { activeRole } = useAuth();
  return activeRole === 'advisor';
}

export default useIsReadOnly;
